import {
  ZipcodePurpose,
  ZipcodeSuccess,
  zipcodeService,
} from '@/services/zipcode';
import { useMutation } from '@tanstack/react-query';

type FetchZipcodeParams = {
  zipcode: string;
  purpose?: ZipcodePurpose;
  policyId?: string;
  productCode?: string;
};

export function useFetchZipcode(defaultPurpose?: ZipcodePurpose) {
  // `data` é ZipcodeSuccess, não a união: o mutationFn LANÇA quando o payload
  // é de erro, então quem consome nunca recebe o ramo ZipcodeError.
  return useMutation<
    { success: boolean; data?: ZipcodeSuccess; error?: string },
    Error,
    string | FetchZipcodeParams
  >({
    mutationKey: ['zipcode', 'fetch'],
    mutationFn: async (input) => {
      const zipcode = typeof input === 'string' ? input : input.zipcode;
      const purpose =
        typeof input === 'string' ? defaultPurpose : (input.purpose ?? defaultPurpose);
      const policyId = typeof input === 'string' ? undefined : input.policyId;
      const productCode =
        typeof input === 'string' ? undefined : input.productCode;

      const response = await zipcodeService.getAddressByZipcode(
        zipcode,
        purpose,
        policyId,
        productCode,
      );
      if (!response.success) {
        throw new Error(response.error || 'Erro ao buscar CEP');
      }

      if (response.data && 'error' in response.data) {
        throw new Error(response.data.message);
      }

      return response as unknown as {
        success: boolean;
        data?: ZipcodeSuccess;
        error?: string;
      };
    },
  });
}
